import KeyboardFocusService from "Services/KeyboardFocusService";
import "../components";

export class App {
  constructor() {
    KeyboardFocusService.init();
  }
}
